import { Reservation } from './reservation';

export type InvoiceStatus =
  | 'UNPAID'
  | 'SENT'
  | 'PAID'
  | 'OVERDUE'
  | 'CANCELLED'
  | 'REFUNDED'
  | 'PENDING';

export const normalizeInvoiceStatus = (status?: string | null): InvoiceStatus | undefined => {
  if (!status) {
    return undefined;
  }

  const normalized = status.trim().toUpperCase() as InvoiceStatus;
  return normalized === 'PENDING' ? 'UNPAID' : normalized;
};

export const isInvoicePayableStatus = (status?: string | null): boolean => {
  const normalized = normalizeInvoiceStatus(status);
  return normalized === 'UNPAID' || normalized === 'SENT' || normalized === 'OVERDUE';
};

export interface InvoiceRecord {
  id: number;
  invoiceNumber: string;
  invoiceDate: string;
  dueDate?: string | null;
  paidDate?: string | null;
  invoiceType?: string;
  status: InvoiceStatus;
  subtotal: number;
  taxAmount?: number;
  discountAmount?: number;
  totalAmount: number;
  amountPaid?: number;
  balanceDue?: number;
  paymentMethod?: string | null;
  paymentReference?: string | null;
  paymentNotes?: string | null;
  paymentId?: number | null;
  linkedToPayment?: boolean;
  description?: string | null;
  notes?: string | null;
  termsAndConditions?: string | null;
  platformCommission?: number;
  processingFee?: number;
  netAmount?: number;
  billingPeriodStart?: string | null;
  billingPeriodEnd?: string | null;
  sentOn?: string | null;
  reminderSentOn?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  reservation?: Reservation | null;
  billToSourceType?: 'CUSTOMER' | 'BILLING_PARTY' | 'GUEST' | string | null;
  billToSourceId?: number | null;
  billToType?: 'PERSON' | 'COMPANY' | string | null;
  billToName?: string | null;
  billToContactPersonName?: string | null;
  billToEmail?: string | null;
  billToPhone?: string | null;
  billToTaxId?: string | null;
  billToRegistrationNumber?: string | null;
  billToStreetAddress?: string | null;
  billToCity?: string | null;
  billToState?: string | null;
  billToPostalCode?: string | null;
  billToCountry?: string | null;
}

export interface InvoicePaymentRequest {
  amount: number;
  paymentMethod: string;
  paymentReference?: string;
  notes?: string;
  paymentDate?: string;
}
